// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Item-module--fadeInAnimation--ed9b3";
export var gridItems = "Item-module--gridItems--ef819";
export var grow = "Item-module--grow--f8c9c";
export var hidden = "Item-module--hidden--68f08";